import styled from "styled-components";
import { ScreenSizes } from '../../../styles/Themes';
import { useSelector } from "react-redux";
import { useEffect } from 'react';
import { useState } from 'react';
import ExternalBurnRedeemButton from '../../buttons/ExternalBurnRedeemButton';


const ClaimEl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: ${ScreenSizes.mobile}) {
    padding: 0px;
  }
`;

function ExternalBurnRedeemButtonArea() {
  const showData = useSelector((state) => state.server.showData);
  const [isBurnStart, setIsBurnStart] = useState(false);
  const burnRedeemInfo = useSelector((state) => state.web3TokenInfo.burnRedeemInfo);
  
  useEffect(()=>{
    if(showData !== undefined){
      const now = Math.floor((new Date()).getTime() / 1000);
      const start = Number(showData.publicData.startDate);
      const end = Number(showData.publicData.endDate);
      console.log("now : ",now);
      console.log("start : ",start);
      console.log("end : ",end);
      if((start <= now) && (end === 0)){
        setIsBurnStart(true);
      }
      if((start <= now) && (now <= end)){
        setIsBurnStart(true);
      }
      if(burnRedeemInfo.redeemedCount === burnRedeemInfo.totalSupply){
        setIsBurnStart(false);
      }
    }
  },[showData]);

  return (
    <ClaimEl>
      <ExternalBurnRedeemButton isBurnStart={isBurnStart}/>
    </ClaimEl>
  );
}
export default ExternalBurnRedeemButtonArea;
